import { useEffect } from "react";
import { useBrandsStore } from "./brandsStore";

export function useBrand(brandId) {
  const { getBrandById, brands } = useBrandsStore();
  const brand = brands?.find((b) => b.id === brandId);

  useEffect(() => {
    if (!brand && brandId) {
      getBrandById(brandId);
    }
  }, [brandId, brand, getBrandById]);

  return brand;
}
